module.exports = __webpack_public_path__ + "media/cards/18-6006231e.png";